import React from 'react';
import { ReferenceArea } from 'recharts';
import { Z_CX } from '../dashboard/_shared';
import "./style.scss";

function Zonas({ tipo }) {
  const zones =
    tipo === "nps"
      ? [
          [0, 30, "#99111108"],
          [30, 50, "#dc262608"],
          [50, 70, "#d9770608"],
          [70, 100, "#05966908"],
        ]
      : Z_CX;
  return (
    <React.Fragment>
      {zones.map(([y1, y2, fill], i) => (
        <ReferenceArea key={i} y1={y1} y2={y2} fill={fill} strokeWidth={0} />
      ))}
    </React.Fragment>
  );
}

export default Zonas;
